import React from 'react';
import { FieldInput, FieldLabel, Field } from '@strapi/design-system';
import { Link } from '@strapi/icons';
import styles from './StatusRow.module.css';
import { FieldAction } from '@strapi/design-system/Field';
import Cross from '@strapi/icons/Cross';
import { CloseIconWrapper } from '../SearchInput/styledComponents/SearchBar.styled';
import { GlossaryConst } from '../../utils';
const StatusRow = /*#__PURE__*/React.memo(({
  isEditable,
  selectedText,
  id,
  currentItem,
  setCurrentItem,
  resetCallback
}) => {
  const handleChange = value => {
    if (!currentItem?.term && !value) {
      return;
    }
    setCurrentItem({
      ...currentItem,
      term: value
    });
    if (!value) {
      resetCallback();
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles.wrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.inputWidth
  }, /*#__PURE__*/React.createElement(Field, null, /*#__PURE__*/React.createElement(FieldLabel, null, GlossaryConst.SELECTED_TEXT), /*#__PURE__*/React.createElement(FieldInput, {
    type: "text",
    value: selectedText,
    disabled: true,
    size: "M"
  }))), /*#__PURE__*/React.createElement("div", {
    className: `${styles.linkIconMarginTop} ${styles.iconWrapper} ${id && styles.active}`
  }, /*#__PURE__*/React.createElement(Link, null)), /*#__PURE__*/React.createElement("div", {
    className: styles.inputWidth
  }, /*#__PURE__*/React.createElement(Field, null, /*#__PURE__*/React.createElement(FieldLabel, null, GlossaryConst.GLOSSARY_TERM_NAME, ":"), /*#__PURE__*/React.createElement(FieldInput, {
    type: "text",
    value: currentItem?.term ?? '',
    disabled: !isEditable,
    onChange: e => handleChange(e.target.value),
    placeholder: GlossaryConst.NO_GLOSSARY_TERM_SELECTED,
    size: "M",
    endAction: /*#__PURE__*/React.createElement(FieldAction, {
      onClick: () => {
        handleChange('');
      }
    }, /*#__PURE__*/React.createElement(CloseIconWrapper, {
      onClick: () => {
        handleChange('');
      }
    }, /*#__PURE__*/React.createElement(Cross, null)))
  }))));
});
export default StatusRow;